import { styled } from "@mui/material/styles";
import { Toolbar, Button, Box, Drawer } from "@mui/material";
import { Link } from "react-router-dom";
const LogoImage = styled("img")({
  maxWidth: "100%",
  height: "40px",
  objectFit: "cover",
});

const Toolbarstyles = {
  root: {
    minHeight: "inherit !important",
    // paddingLeft: "0px !important",
    // paddingRight: "0px !important",
  },
};
const SigninButton = styled(Button)(({ theme }) => ({
  "&.MuiButton-root": {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: theme.typography.fontFamily,
    padding: "0",
    textTransform: "inherit",
  },
}));
const SignUpButton = styled(Button)(({ theme }) => ({
  "&.MuiButton-root": {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: theme.typography.fontFamily,
    background: theme.palette.background.white,
    textTransform: "inherit",
    borderRadius: "32px",
    color: theme.palette.colors.BlackBean,
    marginLeft: "15px",
  },
  "&.MuiButton-root:hover": {
    background: theme.palette.background.whiteHover,
    color: theme.palette.colors.BlackBean,
  },
  [theme.breakpoints.down("sm")]: {
    "&.MuiButton-root": {
      fontSize: "15px",
      padding: "4px 12px",
      marginLeft: "0px",
    },
  },
  [theme.breakpoints.up("md")]: {
    "&.MuiButton-root": {
      fontSize: "15px",
    },
  },
}));

const DeskTopLink = styled(Box)(({ theme }) => ({
  gap: "40px",
  width: "65%",
  alignItems: "center",
  justifyContent: "center",
  "& a": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    textAlign: "center",
    color: "rgba(255, 255, 255, 0.75)",
    fontFamily: theme.typography.fontFamily,
    textDecoration: "none",
    "&.active_link": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "25px",
      textAlign: "center",
      textDecorationLine: "underline",
      color: "#FFFFFF",
    },
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    textAlign: "center",
    color: "rgba(255, 255, 255, 0.75)",
    fontFamily: theme.typography.fontFamily,
    textDecoration: "none",
    cursor: "not-allowed",
  },
}));
const LogoMain = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "30%",
  },
  [theme.breakpoints.up("md")]: {
    width: "20%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "15%",
  },
}));
const AuthButtonMain = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "70%",
    textAlign: "right",
    display: "flex",
    justifyContent: "end",
    gap: "10px",
  },
  [theme.breakpoints.up("md")]: {
    width: "80%",
    textAlign: "right",
    display: "flex",
    justifyContent: "end",
    gap: "10px",
  },
  [theme.breakpoints.down("md")]: {
    width: "80%",
    textAlign: "right",
    display: "flex",
    justifyContent: "end",
    gap: "10px",
  },
  [theme.breakpoints.up("lg")]: {
    width: "15%",
  },
}));
const ToolbarMain = styled(Toolbar)(({ theme }) => ({
  justifyContent: "space-between",
}));

const NotificationBTn = styled(Button)(({ theme }) => ({
  background: "transparent",
  boxShadow: "none",
  padding: "0px",
  minWidth: "auto",
  "&:hover": { background: "transparent", boxShadow: "none", padding: "0px" },
}));

// mobile menu

const DrawerMain = styled(Drawer)(({ theme }) => ({
  width: 240,
  "& .MuiDrawer-paper": {
    width: 240,
    backgroundColor: theme.palette.primary.main,
    padding: "20px 30px",
  },
}));
const LinkMain = styled("ul")(({ theme }) => ({
  listStyle: "none",
  "& li": {
    marginBottom: "10px",
  },
}));
const LinkTo = styled(Link)(({ theme }) => ({
  display: "block",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "25px",
  color: "rgba(255, 255, 255, 0.75)",
  fontFamily: theme.typography.fontFamily,
  textDecoration: "none",
  "&.active_link": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "25px",
    textDecorationLine: "underline",
    color: "#FFFFFF",
  },
}));

export {
  LogoImage,
  Toolbarstyles,
  SigninButton,
  SignUpButton,
  DeskTopLink,
  LogoMain,
  AuthButtonMain,
  ToolbarMain,
  NotificationBTn,
  // mobile
  DrawerMain,
  LinkMain,
  LinkTo,
};
